@if (sidebarService.drawerOpen()) {
  <div class="admin-sidebar__backdrop" (click)="sidebarService.closeDrawer()"></div>
}

<nav class="admin-sidebar"
     [class.admin-sidebar--collapsed]="sidebarService.collapsed()"
     [class.admin-sidebar--open]="sidebarService.drawerOpen()">

  <div class="admin-sidebar__nav">
    @for (link of navLinks; track link.path) {
      <a
        class="admin-sidebar__link"
        [routerLink]="link.path"
        routerLinkActive="admin-sidebar__link--active"
        [routerLinkActiveOptions]="{ exact: !!link.exact }"
        [attr.data-label]="link.label | translate"
        (click)="sidebarService.closeDrawer()"
      >
        <span class="admin-sidebar__icon" aria-hidden="true">{{ link.icon }}</span>
        <span class="admin-sidebar__label">{{ link.label | translate }}</span>
      </a>
    }
    <span class="admin-sidebar__link admin-sidebar__link--disabled" [attr.data-label]="'sidebar.more' | translate">
      <span class="admin-sidebar__icon" aria-hidden="true">⋯</span>
      <span class="admin-sidebar__label">{{ 'sidebar.more' | translate }}</span>
    </span>
  </div>

  <div class="admin-sidebar__footer">
    <div class="admin-sidebar__jannah">
      <div class="admin-sidebar__jannah-header">
        <span class="admin-sidebar__jannah-icon" aria-hidden="true">🌟</span>
        <div class="admin-sidebar__jannah-title">
          <strong>{{ 'sidebar.jannah_journey' | translate }}</strong>
          <span>{{ 'sidebar.level' | translate }} {{ jannahJourney.level }}</span>
        </div>
      </div>
      <div class="admin-sidebar__jannah-bar">
        <div class="admin-sidebar__jannah-bar-fill" [style.width.%]="jannahJourneyPercent"></div>
      </div>
      <span class="admin-sidebar__jannah-xp">{{ jannahJourney.xp }} / {{ jannahJourney.xpTarget }} XP</span>
      <button type="button" class="admin-sidebar__jannah-btn">{{ 'sidebar.view_progress' | translate }}</button>
    </div>

    <button
      type="button"
      class="admin-sidebar__collapse-btn"
      (click)="sidebarService.toggleCollapsed()"
      [attr.aria-label]="sidebarService.collapsed() ? 'Expand sidebar' : 'Collapse sidebar'">
      {{ sidebarService.collapsed() ? '▶' : '◀' }}
    </button>
  </div>
</nav>
